import CryptoJS from "crypto-js";
import loginApi from "@/api/login";

export default {
  formatMobile: function(mobile) {
    return mobile.substr(0, 3) + "****" + mobile.substr(7, 11);
  },
  
  verifyMobile: function(value) {
    var validateReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    return validateReg.test(value);
  },
  
  getRandomStr: function(phone) {
    const _this = this;
    return new Promise((resolve, reject) => {
      loginApi.randomStr(phone).then(res => {
        if (res && res.code === 20000) {
          resolve(res.data);
        } else {
          _this.$message.warning(res.msg);
          reject(res);
        }
      }).catch(err => {
        reject(err);
      });
    });
  },
  
  /**
   * 加密处理
   *
   * @param data  数据
   * @param key   随机秘钥
   * @returns {string}
   */
  encryption: function(data, key) {
    key = CryptoJS.enc.Latin1.parse(key);
    var iv = key;  //偏移向量和秘钥一致
    // 加密
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,  //CBC模式
        padding: CryptoJS.pad.ZeroPadding //零填充
      });
    return encrypted.toString();
  }
};
